import script from "./BorderNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BorderNav.vue?vue&type=script&setup=true&lang=js"

import "./BorderNav.vue?vue&type=style&index=0&id=b85f1618&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b85f1618"]])

export default __exports__